import { Link } from 'react-router-dom';
import type { JobPosting } from '@/types/job';

interface JobCardProps {
  job: JobPosting;
}

function JobCard({ job }: JobCardProps) {
  const formattedDate = new Date(job.postedDate).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <Link
      to={`/jobs/${job.slug}`}
      className="group flex flex-col rounded-xl border border-gray-100 bg-white p-6 shadow-card transition-all duration-300 hover:shadow-card-hover hover:border-brand-purple-100"
    >
      <div className="mb-4 flex items-start justify-between gap-4">
        <h3 className="font-heading text-lg font-semibold text-heading transition-colors group-hover:text-brand-purple">
          {job.title}
        </h3>
        <span className="shrink-0 rounded-full bg-brand-purple-50 px-3 py-1 font-body text-xs font-medium text-brand-purple">
          {job.type}
        </span>
      </div>

      <div className="mb-4 flex flex-wrap items-center gap-4 text-sm text-muted">
        <span className="flex items-center gap-1.5">
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          {job.department}
        </span>
        <span className="flex items-center gap-1.5">
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          {job.location}
        </span>
        {job.salaryRange && (
          <span className="flex items-center gap-1.5">
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {job.salaryRange}
          </span>
        )}
      </div>

      <div className="mt-auto flex items-center justify-between">
        <span className="font-body text-xs text-muted">Posted {formattedDate}</span>
        <span className="font-heading text-sm font-medium text-brand-purple opacity-0 transition-opacity group-hover:opacity-100">
          View Details &rarr;
        </span>
      </div>
    </Link>
  );
}

export default JobCard;
